import QuickBetSwitch from './quickBetSwitch';
import { useBetSlipStore } from '../../useBetSlip';
import { setBetSlipTabTarget } from '../../animationTarget';
export enum BetHeaderTabType {
  BetSlip = 'betSlip',
}

interface BetHeaderTabsProps {
  /** Bet Slip 的数量徽章 */
  betSlipCount?: number;
  /** Open Bets 的数量徽章 */
  openBetsCount?: number;
  /** 是否显示 Bet Slip 警告图标（同一比赛多选） */
  showBetSlipWarning?: boolean;
  /** 关闭按钮回调 */
  onClose?: () => void;
  /** Quick Bet 开启状态 */
  quickBet?: boolean;
  /** Quick Bet 切换回调 */
  onQuickBetChange?: (val: boolean) => void;
  /** 是否登录 */
  isLogin?: boolean;
}

/**
 * 投注单头部 Tab 切换组件
 * 包含 "Bet Slip" 和 "Open Bets" 两个 tab
 */
export const BetHeaderTabs = (props: BetHeaderTabsProps) => {
  const [, , , settingExpanded] = useBetSlipStore();

  const tabsConfig = createMemo(() => [
    {
      type: BetHeaderTabType.BetSlip,
      label: t('Betslip'),
      icon: IconMyBets,
      count: props.betSlipCount,
      showWarning: props.showBetSlipWarning,
    },
  ]);

  const activeConfig = createMemo(() => tabsConfig()[0]);

  return (
    <div
      ref={(el) => {
        setBetSlipTabTarget(el);
      }}
      class="flex h-14 items-center justify-between"
      style={
        props.quickBet
          ? {
              background: 'linear-gradient(90deg, rgba(0, 220, 147, 0.00) 40.14%, rgba(0, 220, 147, 0.30) 100%)',
            }
          : {}
      }
    >
      <button class="flex items-center pl-4 py-1 group">
        <IconBetslip class="size-5 text-neutral-main1 mr-[.12rem] group-hover:text-brand-default transition-colors" />
        <span class="caption-l-semibold text-neutral-main1 cursor-pointer mr-2 group-hover:text-brand-default">
          {activeConfig().label}
        </span>

        {/* 警告图标 */}
        <Show when={activeConfig().showWarning}>
          <IconBetslipWarning class="size-4 text-function-error" />
        </Show>

        {/* 数量徽章 */}
        <Show when={!activeConfig().showWarning && activeConfig().count && activeConfig().count! > 0}>
          <span class="bg-button-general-primary min-w-6 h-6 px-[6px] rounded-full caption-m-semibold text-neutral-alw-black center">
            {activeConfig().count}
          </span>
        </Show>
      </button>

      {/* 关闭按钮 */}
      <div class="h-full pr-3 w-[12.5rem] flex justify-end items-center">
        <Show when={props.isLogin}>
          <div
            onPointerDown={(e) => e.stopPropagation()} // 阻止事件冒泡，防止点击开启quickbet的事件影响到betslip的展开收起事件
            onPointerUp={(e) => e.stopPropagation()}
            onPointerCancel={(e) => e.stopPropagation()}
            onPointerLeave={(e) => e.stopPropagation()}
            class="flex items-center gap-[10px]"
            onClick={(e) => e.stopPropagation()}
          >
            <span
              class={cx(
                props.quickBet ? 'text-neutral-main1' : 'text-neutral-main2',
                'caption-s-medium duration-[300ms]'
              )}
            >
              {t('QUICK BET')}
            </span>
            <QuickBetSwitch
              value={props.quickBet ?? false}
              onChange={(val) => {
                //如果betslip是折叠状态，打开它
                if (val && !settingExpanded()) {
                  props.onClose?.();
                }
                props.onQuickBetChange?.(val);
              }}
              class={cx('transition-[background-color] duration-[500ms]', props.quickBet ? '!bg-brand-default' : '')}
              handleChildren={
                <IconQuickbet
                  class={cx(
                    'size-4 transition-colors duration-[500ms]',
                    props.quickBet ? 'text-brand-default' : 'text-neutral-main2 bg-layer5_5-card'
                  )}
                />
              }
            />
          </div>
        </Show>
        <Show when={!props.isLogin}>
          <Button class="group size-5 bg-button-Icon_only-bright" type="icon">
            <Show
              when={settingExpanded()}
              fallback={<IconCountPlus class="size-3 text-neutral-main1_alt group-hover:text-brand-default" />}
            >
              <IconCountMinus class="size-3 text-neutral-main1_alt group-hover:text-brand-default" />
            </Show>
          </Button>
        </Show>
      </div>
    </div>
  );
};
